import { MouseEventHandler } from "react";
import { NavigateFunction } from "react-router-dom";
import { IAPIObjective } from "redux/configuration/configuration.interface";
import { track } from "utils";
import { Routes, ROUTES } from "utils/constants/router";
import { MyliEventType } from "utils/types/event";
import { IProps } from "./modalConfigStepGoogle.types";

export const handleCTAClick = (
  hideModal: IProps["hideModal"],
  navigate: NavigateFunction,
  marketAction: string | undefined
): MouseEventHandler => {
  const handler: MouseEventHandler = () => {
    hideModal();

    track(MyliEventType.MARKET_ACTION, {
      objective: IAPIObjective.REVIEW_GOOGLE,
    });

    navigate(`../${ROUTES.get(Routes.game).path}`);

    if (marketAction) {
      window.open(marketAction, "_blank");
    }
  };

  return handler;
};
